export const CALCULATOR_DETAILS_SAVE_REQUEST =
  "CALCULATOR_DETAILS_SAVE_REQUEST";
export const CALCULATOR_DETAILS_SAVE_SUCCESS =
  "CALCULATOR_DETAILS_SAVE_SUCCESS";
export const CALCULATOR_DETAILS_SAVE_ERROR = "CALCULATOR_DETAILS_SAVE_ERROR";

export const GET_CALCULATOR_REQUEST = "GET_CALCULATOR_REQUEST";
export const GET_CALCULATOR_SUCCESS = "GET_CALCULATOR_SUCCESS";
export const GET_CALCULATOR_ERROR = "GET_CALCULATOR_ERROR";

export const EDIT_CALCULATOR_REQUEST = "EDIT_CALCULATOR_REQUEST";
export const EDIT_CALCULATOR_SUCCESS = "EDIT_CALCULATOR_SUCCESS";
export const EDIT_CALCULATOR_ERROR = "EDIT_CALCULATOR_ERROR";

export const DELETE_CALCULATOR_REQUEST = "DELETE_CALCULATOR_REQUEST";
export const DELETE_CALCULATOR_SUCCESS = "DELETE_CALCULATOR_SUCCESS";
export const DELETE_CALCULATOR_ERROR = "DELETE_CALCULATOR_ERROR";

export const SET_CALCULATOR_PLATFORM = "SET_CALCULATOR_PLATFORM";
export const SHOW_MOBILE_MODAL = "SHOW_MOBILE_MODAL";

export const RESET_BLOCK_CALCULATOR = "RESET_BLOCK_CALCULATOR";
export const RESET_FLAGS_CALCULATOR = "RESET_FLAGS_CALCULATOR";

const block = {
  loading: false,
  error: "",
  success: false,
};

const initialState = {
  calculatorData: { ...block, data: [] },
  editCalculator: { ...block },
  calculatorDataDelete: { ...block },
  saveCalcDetails: { ...block },
  platforms: [],
  showMobileModal: false,
};

export const CalculatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CALCULATOR_PLATFORM:
      return {
        ...state,
        platforms: action.payload,
      };

    case CALCULATOR_DETAILS_SAVE_REQUEST:
      return {
        ...state,
        saveCalcDetails: {
          ...state.saveCalcDetails,
          loading: true,
          success: false,
        },
      };
    case CALCULATOR_DETAILS_SAVE_SUCCESS:
      return {
        ...state,
        saveCalcDetails: {
          ...state.saveCalcDetails,
          loading: false,
          success: true,
        },
        calculatorData: {
          ...state.calculatorData,
          data: [...state.calculatorData.data, action.payload],
        },
        editCalculator: {
          ...state.editCalculator,
          data: {
            ...action.payload,
          },
        },
      };
    case SHOW_MOBILE_MODAL:
      return {
        ...state,
        showMobileModal: action.payload,
      };
    case CALCULATOR_DETAILS_SAVE_ERROR:
      return {
        ...state,
        saveCalcDetails: {
          ...state.saveCalcDetails,
          loading: false,
          success: false,
          error: action.error,
        },
      };

    case GET_CALCULATOR_REQUEST:
      if (state.calculatorData.data.length > 0) {
        return { ...state };
      }
      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          loading: true,
          success: false,
        },
      };
    case GET_CALCULATOR_SUCCESS:
      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          data: action.payload,
          loading: false,
          success: true,
        },
      };
    case GET_CALCULATOR_ERROR:
      return {
        ...state,
        calculatorData: {
          ...state.calculatorData,
          loading: false,
          success: false,
          error: action.error,
        },
      };

    case EDIT_CALCULATOR_REQUEST:
      return {
        ...state,
        editCalculator: {
          ...state.editCalculator,
          loading: true,
          success: false,
        },
      };
    case EDIT_CALCULATOR_SUCCESS:
      return {
        ...state,
        editCalculator: {
          ...state.editCalculator,
          data: action.payload,
          loading: false,
          success: true,
        },
      };
    case EDIT_CALCULATOR_ERROR:
      return {
        ...state,
        editCalculator: {
          ...state.editCalculator,
          loading: false,
          success: false,
          error: action.error,
        },
      };

    case DELETE_CALCULATOR_REQUEST:
      return {
        ...state,
        calculatorDataDelete: {
          ...state.calculatorDataDelete,
          loading: true,
          success: false,
          error: "",
        },
      };
    case DELETE_CALCULATOR_SUCCESS:
      return {
        ...state,
        calculatorDataDelete: {
          ...state.calculatorDataDelete,
          loading: false,
          success: true,
        },
      };
    case DELETE_CALCULATOR_ERROR:
      return {
        ...state,
        calculatorDataDelete: {
          ...state.calculatorDataDelete,
          loading: false,
          success: false,
          error: action.error,
        },
      };

    //reset block with flag and data
    case RESET_BLOCK_CALCULATOR:
      return {
        ...state,
        [action.payload.blockType]: {
          ...state[action.payload.blockType],
          ...initialState[action.payload.blockType],
        },
      };

    //reset only flags(block)
    case RESET_FLAGS_CALCULATOR:
      return {
        ...state,
        [action.payload.blockType]: {
          ...state[action.payload.blockType],
          ...block,
        },
      };

    default:
      return state;
  }
};
